<!--  -->
<template>
  <div>
    <el-form
      label-position="right"
      label-width="100px"
      :model="formLabelAlign"
    >
      <el-form-item label="区域">
        <el-select
          v-model="formLabelAlign.area"
          placeholder="请选择"
        >
          <el-option
            v-for="item in areaarr"
            :key="item.value"
            :label="item.area"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="IP">
        <el-input
          v-model="formLabelAlign.ip"
          placeholder="请输入内容"
        />
      </el-form-item>
      <el-form-item label="客户端地址">
        <el-input
          v-model="formLabelAlign.client_host"
          placeholder="请输入内容"
        />
      </el-form-item>
      <el-form-item label="绑定上限">
        <el-input
          v-model="formLabelAlign.max_bind"
          min="0"
          type="number"
          placeholder="请输入绑定上限"
          @blur="chagerracher"
        />
      </el-form-item>
      <el-form-item label="最大上限">
        <el-input
          v-model="formLabelAlign.set_max_bind"
          min="0"
          type="number"
          placeholder="请输入绑定上限"
          @blur="setchagerracher"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbit"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { clientareaList, clientstore, clientupdate } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      areaarr: [],
      formLabelAlign: {
        area: 1,
        ip: '',
        client_host: '',
        max_bind: 8,
        set_max_bind: 8
      },
      type: null,
      id: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      if (type === 1) {
        this.type = type
      } else {
        this.type = type
        this.id = item.id
        this.formLabelAlign.area = item.area
        this.formLabelAlign.ip = item.ip
        this.formLabelAlign.client_host = item.client_host
        this.formLabelAlign.max_bind = item.max_bind
        this.formLabelAlign.set_max_bind = item.set_max_bind
      }
      this.arealist()
    },
    async arealist() {
      const data = await clientareaList()
      this.areaarr = data.data
    },
    async sumbit() {
      if (this.formLabelAlign.area === '') {
        this.$message.error('请选择区域')
        return
      }
      if (this.formLabelAlign.ip === '') {
        this.$message.error('请输入IP地址')
        return
      }
      if (this.formLabelAlign.client_host === '') {
        this.$message.error('请输入客户端地址')
        return
      }
      if (this.formLabelAlign.max_bind === '') {
        this.$message.error('请输入绑定上限')
        return
      }
      if (this.formLabelAlign.set_max_bind === '') {
        this.$message.error('请输入最大上限')
        return
      }

      if (this.type === 1) {
        const data = await clientstore(this.formLabelAlign)
        console.log('data', data)
        this.$emit('updata')
      } else {
        const data = await clientupdate({
          ...this.formLabelAlign,
          id: this.id
        })
        console.log('data', data)
        this.$emit('updata')
      }
    },
    chagerracher() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.max_bind < 0 && this.formLabelAlign.max_bind != '') {
        this.formLabelAlign.max_bind = 0
      }
    },
    setchagerracher() {
      // eslint-disable-next-line eqeqeq
      if (this.formLabelAlign.set_max_bind < 0 && this.formLabelAlign.set_max_bind != '') {
        this.formLabelAlign.set_max_bind = 0
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
